import * as React from 'react';
// @ts-expect-error
import {Controller} from 'react-hook-form';
// @ts-expect-error
import type {Control, Watch} from 'react-hook-form';

import {EditableFormField} from 'shells/form/editable-form-field';
import {FormField} from 'shells/form/form-field';

import {getInputStyles} from '../../../../helpers';
import type {ElementType} from '../../../../types';

import {useFocusInput} from './use-focus-input';

import styles from './field-styles.module.css';

type Props = {
    control: Control;
    name: string;
    watch: Watch;
    isActive: boolean;
    activeElement: ElementType | null | undefined;
};

export function DateField(props: Props) {
    const [shouldFocusOnMount, setShouldFocusOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'label')
    );
    const [shouldFocusInputOnMount, setShouldFocusInputOnMount] = React.useState<boolean>(
        Boolean(props.isActive && props.activeElement && props.activeElement === 'input')
    );
    const isRequired = props.watch(`${props.name}.isRequired`);
    const color = props.watch('inputStyle.color');
    const inputColor = props.watch('inputStyle.inputColor');
    const fontSize = props.watch('inputStyle.fontSize');
    const border = props.watch('inputStyle.border');
    const borderRadius = props.watch('inputStyle.borderRadius');
    const label = props.watch(`${props.name}.label`);

    const dateFieldRef = React.useRef(null);

    useFocusInput(dateFieldRef, shouldFocusInputOnMount, setShouldFocusInputOnMount);

    const _localStyles = getInputStyles({
        borderRadius,
        border,
        fontSize,
        color,
        inputColor,
    });

    return (
        <div style={{fontSize: `${fontSize}px`}}>
            <Controller
                name={`${props.name}.label`}
                control={props.control}
                rules={{
                    maxLength: {
                        value: 255,
                        message: 'Field names can’t exceed 255 characters',
                    },
                }}
                // @ts-expect-error
                render={({field, fieldState}) => {
                    const errorMessage = fieldState.error ? fieldState.error.message : undefined;

                    return (
                        <EditableFormField
                            innerId={field.id}
                            label={label}
                            errorMessage={errorMessage}
                            smallBottomMargin={true}
                            editableLabelProps={{
                                onSaveNewValue: (newName) => {
                                    field.onChange(newName);

                                    return new Promise((resolve) => {
                                        // @ts-expect-error
                                        resolve();
                                    });
                                },
                                placeholder: 'Add a title',
                                allowSavingEmpty: false,
                                shouldAllowUndo: false,
                                required: isRequired,
                                tooltip: null,
                                // @ts-expect-error
                                customStyle: {color},
                                isWhite: true,
                                shouldFocusOnMount,
                                onFocusedOnMount: () => setShouldFocusOnMount(false),
                            }}
                            isActive={props.isActive}
                        >
                            <Controller
                                name={`${props.name}.placeholder`}
                                control={props.control}
                                rules={{
                                    maxLength: {
                                        value: 255,
                                        message: 'Placeholders can’t exceed 255 characters',
                                    },
                                }}
                                // @ts-expect-error
                                render={({field: dateField, fieldState: dateFieldState}) => {
                                    const textFieldErrorMessage = dateFieldState.error
                                        ? dateFieldState.error.message
                                        : undefined;

                                    return (
                                        <FormField
                                            innerId='placeholder'
                                            errorMessage={textFieldErrorMessage}
                                        >
                                            <input
                                                style={{
                                                    ...styles,
                                                    boxSizing: 'border-box',
                                                    width: '100%',
                                                }}
                                                type='date'
                                                name={props.name}
                                                value={dateField.value}
                                            />
                                        </FormField>
                                    );
                                }}
                            />
                        </EditableFormField>
                    );
                }}
            />
        </div>
    );
}
